/**
 * Shared constants across all platforms (Native, Web, etc.)
 */

/**
 * The identifier used for local data created when in Visitor Mode (unauthenticated).
 */
export const VISITOR_ID = "visitor";

/**
 * Standard HTTP Status Codes
 */
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;

/**
 * The slug for the default "Inbox" list.
 */
export const INBOX_SLUG = "inbox";

/**
 * A stable reference for an empty array to prevent unnecessary re-renders in hooks.
 */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);

/**
 * Deep Linking Configuration
 */
export const APP_SCHEME = "stockpilot";
export const APP_DOMAIN = "app.stockpilot.app";

/**
 * SOFT_DELETE_STANDARD — retención de la papelera (días) antes de la purga
 * física server-side (job horario, ver `core-rust/src/db/trash.rs`). Usada
 * también en el cliente para el countdown "se eliminará definitivamente en N
 * días" de la vista de papelera. Debe coincidir con el default del servidor
 * (`TRASH_PURGE_DAYS`, env var; 0 = purga desactivada).
 */
export const TRASH_PURGE_DAYS = 30;
